import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "app/store";
import { ImportedCustomEventSchema } from "types/customEvents";

export interface InitialState {
  imported: (ImportedCustomEventSchema & {
    importedId?: number;
    code?: number;
    message?: string;
    errors?: any[];
  })[];
}

const initialState: InitialState = {
  imported: [],
};

export const customEventSchemasSlice = createSlice({
  name: "customEventSchemas",
  initialState,
  reducers: {
    setImportedCustomEventSchemas: (state, action: PayloadAction<any>) => {
      state.imported = action.payload;
    },
    updateImportedCustomEventSchemas: (
      state,
      action: PayloadAction<{
        importedId: number;
        customEventSchema: any;
        isSaved?: boolean;
      }>,
    ) => {
      state.imported = state.imported.map((item, index) => {
        if (index === action.payload.importedId) {
          return {
            isSaved: action.payload.isSaved,
            ...action.payload.customEventSchema,
          };
        }

        return item;
      });
    },
  },
});

export const {
  setImportedCustomEventSchemas,
  updateImportedCustomEventSchemas,
} = customEventSchemasSlice.actions;

export const selectImportedCustomEventSchemas = (state: RootState) =>
  state.customEventSchemas.imported;

export default customEventSchemasSlice.reducer;
